import { Injectable } from '@angular/core';
import { EstimateItem } from '../../domain/models/estimate-item.model';
import { EstimateItemDto } from '../dtos/estimate-item.dto';

@Injectable()
export class EstimateItemMapper {
  public toEstimateItem(dto: EstimateItemDto): EstimateItem {
    return {
      externalId: dto.ExternalId,
      externalUrl: dto.ExternalUrl,
      name: dto.Name,
      typeCode: dto.TypeCode,
      usageType: dto.UsageType,
      quantity: dto.Quantity,
      unit: dto.Unit,
      price: dto.Price,
      priceWithVat: dto.PriceWithVat,
      minPrice: dto.MinPrice,
      maxPrice: dto.MaxPrice,
      sum: dto.Sum,
      sumVat: dto.SumVat,
      sumTotal: dto.SumTotal,
      minSumTotal: dto.MinSumTotal,
      maxSumTotal: dto.MaxSumTotal,
      declined: dto.Declined,
      templateName: dto.TemplateName,
    };
  }
}
